import {DataFetcher} from '@aboutyou/data-fetcher';
import {Head} from '@aboutyou/head-elements';
import React from 'react';

import {GetPageMetaDataResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/meta/service.types';
import {TrackContentPageView} from '@aboutyou/tracking';
import {
  extractMetaAndLinkTags,
  isSeoData,
  SeoMeta,
  setDataTestIds,
} from '../../../shared-deprecated/metaUtils';
import {useBasketPageMetaData} from '../hooks/useBasketPageMetaData';

export const Meta: React.FC = () => {
  return (
    <DataFetcher
      request={useBasketPageMetaData()}
      Error={() => null}
      View={View}
    />
  );
};

const View: React.FC<GetPageMetaDataResponse> = pageMeta => {
  const meta: SeoMeta = pageMeta.meta;

  if (!isSeoData(meta)) {
    return null;
  }

  const seoData = meta.type.seoData;
  const [metaTags, linkTags] = setDataTestIds(
    extractMetaAndLinkTags(seoData.elements),
  );

  return (
    <>
      <TrackContentPageView pageTitle={seoData.title} />
      <Head meta={metaTags} link={linkTags}>
        <title data-testid="MetaTitle">{seoData.title}</title>
      </Head>
    </>
  );
};
